// const styled = withStyles((theme) => ({
//     root: {
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'space-between',
//     },
//     list: {
//         listStyleType: 'none',
//         padding: 0,
//         margin: 0,
//     },
//     container: {
//         display: 'block',
//         whiteSpace: 'nowrap',
//         maxWidth: 150,
//         overflow: 'hidden',
//         textOverflow: 'ellipsis',
//         marginLeft: 'auto',
//     },
// }));

const Time = ({ value, data }) => {
    const dateTimeStr = `${data.createdMoneyBoxDate}T${value}Z`;
    const formattedTime = new Date(dateTimeStr).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });

    return (
        <div>
            <span>{formattedTime}</span>
        </div>
    );
};

export default Time;
